import _ from 'lodash';
import React, { useMemo, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import CategoryGroup from '../../models/CategoryGroup';
import CategoryGroupComponent from './CategoryGroupComponent';
import { Droppable, Draggable } from 'react-beautiful-dnd';
import BudgetListModes from './BudgetListModes';
import Category from "../../models/Category";
import SpentAndBudgetedSummary from "./SpentAndBudgetedSummary.jsx";
import InputSwitch from "./InputSwitch.jsx";
import {
	changeBudgetListModeToDashboard,
	changeBudgetListModeToEditAmounts,
	changeBudgetListModeToTypes
} from "../../redux/actions/dashboard.js";
import Card from "./Card.jsx";

export default function CategoriesComponent({ shouldShowEditCategoryOptions, ...props }) {
	const showTotalsWithinEachCategoryFeatureActive = useSelector((state) => state.settings.showTotalsWithinEachCategoryFeatureActive);
	const separateBudgetTabsFeatureActive = useSelector((state) => state.settings.separateBudgetTabsFeatureActive);
	const lastChangedBudget = useSelector((state) => state.dashboard.lastChangedBudget);
	const refreshingData = useSelector((state) => state.dashboard.refreshingData);
	const transactionFinder = useSelector((state) => state.dashboard.transactionFinder);
	const dispatch = useDispatch();

	const {
		showTotals,
		categories,
		categoryGroups,
		categoryType,
		categoryGroupsByType,
		categoryGroupType,
		editBudgetListMode,
		selectedDates,
		selectedDate
	} = props;

	const newCategoryGroup = useRef(new CategoryGroup({
		type: categoryType
	}));
	let isFirst = 1;
	const categoryGroupsToShow = categoryGroupsByType[categoryGroupType.id];
	const categoryChangeDependencies = [categories, categoryGroups, selectedDates, lastChangedBudget, refreshingData];
	const { totalSpent, totalMade, totalBudgeted, totalSaved, totalSpentOnLoans } = useMemo(() => {
		// HI
		return Category.getSummaryTotals(categories, categoryGroups, selectedDates);
	}, categoryChangeDependencies);

	const numberOfDatesSelected = _.size(selectedDates);

	const { uncategorizedSpent, uncategorizedIncome } = useMemo(() => {
		return Category.getUncategorizedTotals(selectedDates);
	}, categoryChangeDependencies);

	function updateBudgetAmountsChange() {
		if(editBudgetListMode === BudgetListModes.AMOUNTS) {
			dispatch(changeBudgetListModeToDashboard());
		} else {
			dispatch(changeBudgetListModeToEditAmounts());
		}
	}

	function editCategoriesChange() {
		if(editBudgetListMode === BudgetListModes.TYPES) {
			dispatch(changeBudgetListModeToDashboard());
		} else {
			dispatch(changeBudgetListModeToTypes());
		}
	}

	return (
		<React.Fragment>
			{shouldShowEditCategoryOptions &&
			<div className='section'>
				<div className='row'>
					<div className='col s12 m6'>
						<InputSwitch
							disabled={numberOfDatesSelected !== 1}
							onChange={updateBudgetAmountsChange}
							checked={editBudgetListMode === BudgetListModes.AMOUNTS}
							onContent={
								<React.Fragment>
									{numberOfDatesSelected === 1 &&
									<span>Update Budget Amounts For {selectedDate.format('MMMM YYYY')}</span>
									}
									{numberOfDatesSelected !== 1 &&
									<span>Cannot Edit Budgets, Multiple Months Selected</span>
									}
								</React.Fragment>
							}
						/>
					</div>
					<div className='col s12 m6'>
						<InputSwitch
							onChange={editCategoriesChange}
							checked={editBudgetListMode === BudgetListModes.TYPES}
							onContent={
								<span>Edit Categories</span>}
						/>
					</div>
				</div>
			</div>
			}
			{showTotals && showTotalsWithinEachCategoryFeatureActive && totalSpent !== undefined && totalBudgeted !== undefined &&
			<div>
				<SpentAndBudgetedSummary
					income={totalMade}
					spent={totalSpent}
					budgeted={totalBudgeted}
				/>
			</div>
			}
			{(!!uncategorizedIncome || !!uncategorizedSpent) &&
			<div className='category_group uncategorized_totals'>
				<Card>
					<h5 className='heading'>Uncategorized Totals</h5>
					<SpentAndBudgetedSummary
						income={uncategorizedIncome}
						spent={uncategorizedSpent}
						budgeted={null}
					/>
				</Card>
			</div>
			}
			{!separateBudgetTabsFeatureActive &&
			<h4>{categoryGroupType.name}</h4>
			}
			<div
				className='categories'>
				<div>
					<Droppable
						droppableId={`categoryGroupHolder-${categoryType}`}
						type='CATEGORY_GROUP'>
						{(provided, snapshot) => (
							<div
								ref={provided.innerRef}
								{...provided.droppableProps}
							>
								{categoryGroupsToShow && categoryGroupsToShow.map((categoryGroup, index) => {
									return (
										<Draggable
											draggableId={`draggableCategoryGroup-${categoryGroup.id}`}
											index={index}
											key={categoryGroup.id}
										>
											{(provided, snapshot) => (
												<div
													ref={provided.innerRef}
													{...provided.draggableProps}
												>
													<CategoryGroupComponent
														dragHandleProps={provided.dragHandleProps}
														categoryGroup={categoryGroup}
														showCategoryHeader={true || isFirst-- > 0}
														index={index}
														{...props}
													/>
												</div>

											)}
										</Draggable>

									);
								})}
								{provided.placeholder}
							</div>
						)}
					</Droppable>
					{(separateBudgetTabsFeatureActive || editBudgetListMode === BudgetListModes.TYPES) &&
					<CategoryGroupComponent
						{...props}
						categoryGroup={newCategoryGroup.current}
						index={0}
					/>
					}
				</div>
			</div>
		</React.Fragment>
	);
}
